package com.shadowings.gero.data.lessons.chapter6

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.ui.Alignment
import androidx.compose.ui.unit.dp
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.TrueFalseContent
import com.shadowings.gero.presentation.component.MdCWord
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_classi_verbali_alyn_1
import gero.composeapp.generated.resources.exp_content_classi_verbali_alyn_2
import gero.composeapp.generated.resources.exp_content_classi_verbali_alyn_3
import gero.composeapp.generated.resources.exp_content_classi_verbali_alyn_4
import gero.composeapp.generated.resources.exp_content_classi_verbali_alyn_5
import gero.composeapp.generated.resources.exp_content_classi_verbali_alyn_6
import gero.composeapp.generated.resources.exp_content_classi_verbali_alyn_7
import gero.composeapp.generated.resources.exp_content_classi_verbali_alyn_8
import gero.composeapp.generated.resources.exp_content_classi_verbali_alyn_9
import gero.composeapp.generated.resources.exp_content_classi_verbali_nilo_1
import gero.composeapp.generated.resources.exp_content_classi_verbali_nilo_2
import gero.composeapp.generated.resources.exp_content_classi_verbali_zeta_1
import gero.composeapp.generated.resources.exp_content_classi_verbali_zeta_2
import gero.composeapp.generated.resources.exp_content_classi_verbali_zeta_3
import gero.composeapp.generated.resources.exp_content_classi_verbali_zeta_4
import gero.composeapp.generated.resources.exp_content_classi_verbali_zeta_5
import gero.composeapp.generated.resources.exp_title_classi_verbali
import gero.composeapp.generated.resources.quiz_classi_verbali_1
import gero.composeapp.generated.resources.quiz_classi_verbali_2
import gero.composeapp.generated.resources.quiz_classi_verbali_3
import gero.composeapp.generated.resources.quiz_classi_verbali_4
import gero.composeapp.generated.resources.quiz_classi_verbali_5
import gero.composeapp.generated.resources.quiz_classi_verbali_6
import gero.composeapp.generated.resources.quiz_classi_verbali_7
import gero.composeapp.generated.resources.quiz_classi_verbali_8

fun getClassiVerbaliContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_classi_verbali,
            content = Res.string.exp_content_classi_verbali_alyn_1,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_classi_verbali,
            content = Res.string.exp_content_classi_verbali_alyn_2,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_classi_verbali,
            content = Res.string.exp_content_classi_verbali_alyn_8,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_classi_verbali,
            content = Res.string.exp_content_classi_verbali_alyn_9,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = { MdCWord("X1D46", rtl = false, cart = false) }
        ),
        ExplanationContent(
            title = Res.string.exp_title_classi_verbali,
            content = Res.string.exp_content_classi_verbali_zeta_1,
            face = Faces.Happy,
            character = Characters.Zeta,
            composable = { MdCWord("X1D46", rtl = false, cart = false) }
        ),
        ExplanationContent(
            title = Res.string.exp_title_classi_verbali,
            content = Res.string.exp_content_classi_verbali_alyn_3,
            face = Faces.Serious,
            character = Characters.Alyn,
            composable = { MdCWord("R4:X1*Q3", rtl = false, cart = false) }
        ),
        ExplanationContent(
            title = Res.string.exp_title_classi_verbali,
            content = Res.string.exp_content_classi_verbali_zeta_2,
            face = Faces.Happy,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_classi_verbali,
            content = Res.string.exp_content_classi_verbali_nilo_1,
            face = Faces.Serious,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_classi_verbali,
            content = Res.string.exp_content_classi_verbali_zeta_3,
            face = Faces.Idle,
            character = Characters.Zeta,
            composable = {
                Column(
                    verticalArrangement = Arrangement.spacedBy(8.dp),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    MdCWord("E34:N35", rtl = false, cart = false)
                    MdCWord("E34:N35:N35", rtl = false, cart = false)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_classi_verbali,
            content = Res.string.exp_content_classi_verbali_alyn_4,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_classi_verbali,
            content = Res.string.exp_content_classi_verbali_zeta_4,
            face = Faces.Idle,
            character = Characters.Zeta,
            composable = { MdCWord("O1:D21-D54", rtl = false, cart = false) }
        ),
        ExplanationContent(
            title = Res.string.exp_title_classi_verbali,
            content = Res.string.exp_content_classi_verbali_alyn_5,
            face = Faces.Serious,
            character = Characters.Alyn,
            composable = { MdCWord("O1:D21-D21:D54", rtl = false, cart = false) }
        ),
        ExplanationContent(
            title = Res.string.exp_title_classi_verbali,
            content = Res.string.exp_content_classi_verbali_nilo_2,
            face = Faces.Serious,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_classi_verbali,
            content = Res.string.exp_content_classi_verbali_zeta_5,
            face = Faces.Surprised,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_classi_verbali,
            content = Res.string.exp_content_classi_verbali_alyn_6,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_classi_verbali,
            content = Res.string.exp_content_classi_verbali_alyn_7,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
    )
}

fun getClassiVerbaliQuizContent(): List<IQuizContent> {
    return listOf(
        TrueFalseContent(
            text = Res.string.quiz_classi_verbali_1,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_classi_verbali_2,
            correct = false
        ),
        TrueFalseContent(
            text = Res.string.quiz_classi_verbali_3,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_classi_verbali_4,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_classi_verbali_5,
            correct = false
        ),
        TrueFalseContent(
            text = Res.string.quiz_classi_verbali_6,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_classi_verbali_7,
            correct = false
        ),
        TrueFalseContent(
            text = Res.string.quiz_classi_verbali_8,
            correct = true
        )
    )
}

